import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { FluentProvider, webLightTheme } from '@fluentui/react-components'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { AppContainer } from './GlobalStyles'
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary'

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <BrowserRouter>
    <FluentProvider theme={webLightTheme}>
      <QueryClientProvider client={queryClient}>
        <AppContainer>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </AppContainer>
      </QueryClientProvider>
    </FluentProvider>
  </BrowserRouter>
)
